/* WKS dimension range slider.
   Drives Shopify's native metafield list-filter checkboxes (Hoogte/Breedte/Diepte).
   The slider ONLY toggles which (hidden) checkboxes are checked; the actual filtering is
   performed server-side by Shopify's native facets, whose values are proven-correct.
   Re-initialises automatically after each AJAX filter re-render via connectedCallback. */
(function () {
  'use strict';

  class DimensionRange extends HTMLElement {
    connectedCallback() {
      if (this._built) return;
      this._built = true;
      this.build();
    }

    build() {
      var checks = Array.prototype.slice.call(
        this.querySelectorAll('.wks-dimr__checks input[type="checkbox"]')
      );
      this.minR = this.querySelector('.wks-dimr__range--min');
      this.maxR = this.querySelector('.wks-dimr__range--max');
      this.fill = this.querySelector('.wks-dimr__fill');
      this.lblMin = this.querySelector('.wks-dimr__min');
      this.lblMax = this.querySelector('.wks-dimr__max');
      if (!checks.length || !this.minR || !this.maxR || !this.fill) return;

      // Sort the discrete values numerically; keep one checkbox per distinct value.
      var seen = {};
      var entries = [];
      checks.forEach(function (c) {
        var num = parseFloat(String(c.value).replace(',', '.'));
        if (isNaN(num) || seen[num]) return;
        seen[num] = true;
        entries.push({ num: num, el: c });
      });
      entries.sort(function (a, b) { return a.num - b.num; });

      this.nums = entries.map(function (e) { return e.num; });
      this.els = entries.map(function (e) { return e.el; });
      this.allChecks = checks;
      this.n = entries.length;
      if (!this.n) return;

      var maxIdx = this.n - 1;
      [this.minR, this.maxR].forEach(function (r) {
        r.min = 0; r.max = maxIdx; r.step = 1;
      });

      // Initial handle positions derived from which values are currently active.
      var lo = 0, hi = maxIdx, active = [];
      this.els.forEach(function (el, i) { if (el.checked) active.push(i); });
      if (active.length) {
        lo = Math.min.apply(null, active);
        hi = Math.max.apply(null, active);
      }
      this.minR.value = lo;
      this.maxR.value = hi;

      if (this.n < 2) { this.minR.disabled = true; this.maxR.disabled = true; }

      var self = this;
      this.minR.addEventListener('input', function () { self.onDrag('min'); });
      this.maxR.addEventListener('input', function () { self.onDrag('max'); });

      this.paint(); // reflect UI only — does NOT touch checkboxes or submit
    }

    onDrag(which) {
      var lo = parseInt(this.minR.value, 10);
      var hi = parseInt(this.maxR.value, 10);
      if (lo > hi) {
        if (which === 'min') { this.maxR.value = lo; }
        else { this.minR.value = hi; }
      }
      this.paint();
      this.sync();
      // The native 'input' event bubbles to the <form> and triggers Ella's debounced
      // AJAX filter with the checkbox state we just set — no manual submit needed.
    }

    paint() {
      var lo = parseInt(this.minR.value, 10);
      var hi = parseInt(this.maxR.value, 10);
      var denom = this.n > 1 ? this.n - 1 : 1;
      this.fill.style.left = (lo / denom) * 100 + '%';
      this.fill.style.right = (100 - (hi / denom) * 100) + '%';
      if (this.lblMin) this.lblMin.textContent = this.fmt(this.nums[lo]);
      if (this.lblMax) this.lblMax.textContent = this.fmt(this.nums[hi]);
      // Keep both handles grabbable when they overlap.
      if (lo === hi) {
        if (hi < this.n - 1) { this.maxR.style.zIndex = 6; this.minR.style.zIndex = 4; }
        else { this.minR.style.zIndex = 6; this.maxR.style.zIndex = 4; }
      } else {
        this.minR.style.zIndex = 4; this.maxR.style.zIndex = 5;
      }
    }

    sync() {
      var lo = parseInt(this.minR.value, 10);
      var hi = parseInt(this.maxR.value, 10);
      var full = (lo === 0 && hi === this.n - 1);
      this.allChecks.forEach(function (c) { c.checked = false; });
      if (!full) {
        for (var i = lo; i <= hi; i++) {
          if (this.els[i]) this.els[i].checked = true;
        }
      }
    }

    fmt(num) {
      return (Math.round(num * 100) / 100).toString().replace('.', ',') + ' cm';
    }
  }

  if (!customElements.get('dimension-range')) {
    customElements.define('dimension-range', DimensionRange);
  }
})();
